var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.828 1.375c-.696 0-1.363.277-1.856.769L10.5 3.616 9.002 2.12a2.125 2.125 0 00-3.005 0L4.118 3.997c-.83.83-.83 2.176 0 3.006L5.616 8.5 4.144 9.972a2.625 2.625 0 00-.769 1.856V19A3.625 3.625 0 007 22.625h10A3.625 3.625 0 0020.625 19V5A3.625 3.625 0 0017 1.375h-3.172zM6.5 7.616L9.616 4.5 8.118 3.003a.875.875 0 00-1.237 0L5.002 4.88a.875.875 0 000 1.238L6.5 7.616zm6.356-4.588c.258-.258.608-.403.972-.403H17A2.375 2.375 0 0119.375 5v14A2.375 2.375 0 0117 21.375H7A2.375 2.375 0 014.625 19v-7.172c0-.364.145-.714.403-.972l7.828-7.828z",
    fill: "currentColor"
  })));
}
export default SvgContainerLg;